// extracted by mini-css-extract-plugin
export default {"container":"RecordCount_container__xjDXk","count":"RecordCount_count__9GkM6","actions":"RecordCount_actions__oPT5I"};